import { useWizardContext } from 'redesign';
import { useAlert } from 'shared/components/alerts';
import { RenderUnsettledUI, SmallError, SmallLoader } from 'shared/components';
import { useBulkActionResultContext } from 'shared/providers/bulk-action-provider';
import { useBulkOpenShiftsToPartners, useGetShiftsPartners } from 'api';
import { BulkForwardDialogForm } from './dialog-components/dialog-form';
import { BulkForwardFormInput } from './types';

type Props = {
  onClose: () => void;
};

export const BulkShiftForwardFormProvider = ({ onClose }: Props) => {
  const { selectedIds, setMutationResult } = useBulkActionResultContext();
  const getShiftEligiblePartnersQuery = useGetShiftsPartners(selectedIds);
  const mutation = useBulkOpenShiftsToPartners();
  const { alertError } = useAlert();
  const { nextStep } = useWizardContext();

  const onSubmit = (data: BulkForwardFormInput) => {
    mutation.mutate(
      {
        shiftIds: selectedIds,
        partnerIds: data.partners.map((partner) => partner.id),
      },
      {
        onSuccess: (data) => {
          setMutationResult(data);
          nextStep();
        },
        onError: (e) => alertError(e),
      }
    );
  };

  if (getShiftEligiblePartnersQuery.status !== 'success') {
    return (
      <RenderUnsettledUI
        renderLoading={<SmallLoader />}
        renderError={(error) => <SmallError error={error} />}
        data={getShiftEligiblePartnersQuery}
      />
    );
  }

  return (
    <BulkForwardDialogForm
      availablePartners={getShiftEligiblePartnersQuery.data}
      numberOfShifts={selectedIds.length}
      onSubmit={onSubmit}
      closeDialog={onClose}
    />
  );
};
